import React from 'react';
import LoginView from '../components/LoginView';
import LoginPanel from '@components/Login/LoginPanel';

export default function Login() {
  return (
    <LoginView>
      <LoginPanel />
    </LoginView>
  );
}
